module.exports = __webpack_public_path__ + "static/media/buildingAlexa.c1135f92.png";